export const workEnvironment = {
  junior: {
    macos: [
      { step: 'Install Chrome', command: 'brew install --cask google-chrome' },
      { step: 'Install Slack', command: 'brew install --cask slack' },
      { step: 'Install Notion', command: 'brew install --cask notion' },
      { step: 'Install Figma', command: 'brew install --cask figma' },
      { step: 'Install Zoom', command: 'brew install --cask zoom' },
      { step: 'Install Microsoft Office', command: 'brew install --cask microsoft-office' },
      { step: 'Install Google Drive', command: 'brew install --cask google-drive' }
    ],
    windows: [
      { step: 'Install Chrome', command: 'choco install googlechrome' },
      { step: 'Install Slack', command: 'choco install slack' },
      { step: 'Install Notion', command: 'choco install notion' },
      { step: 'Install Figma', command: 'choco install figma' },
      { step: 'Install Zoom', command: 'choco install zoom' },
      { step: 'Install Microsoft Office', command: 'choco install office365business' },
      { step: 'Install OneDrive', command: 'choco install onedrive' }
    ],
    linux: [
      { step: 'Install Chrome', command: 'wget -q -O - https://dl.google.com/linux/linux_signing_key.pub | sudo apt-key add - && echo "deb [arch=amd64] http://dl.google.com/linux/chrome/deb/ stable main" | sudo tee /etc/apt/sources.list.d/google-chrome.list && sudo apt update && sudo apt install google-chrome-stable' },
      { step: 'Install Slack', command: 'sudo snap install slack --classic' },
      { step: 'Install Figma', command: 'sudo snap install figma-linux' },
      { step: 'Install Zoom', command: 'sudo snap install zoom-client' },
      { step: 'Install LibreOffice', command: 'sudo apt install libreoffice' },
      { step: 'Install Dropbox', command: 'sudo apt install dropbox' }
    ]
  },
  mid: {
    macos: [
      { step: 'Install Amplitude', command: 'Web-based analytics platform' },
      { step: 'Install Mixpanel', command: 'Web-based analytics platform' },
      { step: 'Install Tableau Desktop', command: 'brew install --cask tableau' },
      { step: 'Install Miro', command: 'brew install --cask miro' },
      { step: 'Install Airtable', command: 'brew install --cask airtable' },
      { step: 'Install Loom', command: 'brew install --cask loom' }
    ],
    windows: [
      { step: 'Install Power BI Desktop', command: 'choco install powerbi' },
      { step: 'Install Tableau Desktop', command: 'choco install tableau-desktop' },
      { step: 'Install Miro', command: 'choco install miro' },
      { step: 'Install Airtable', command: 'Web-based platform' },
      { step: 'Install Loom', command: 'choco install loom' },
      { step: 'Install Azure Data Studio', command: 'choco install azure-data-studio' }
    ],
    linux: [
      { step: 'Install R and RStudio', command: 'sudo apt install r-base && sudo apt install rstudio' },
      { step: 'Install Python analytics tools', command: 'pip3 install pandas numpy matplotlib seaborn jupyter' },
      { step: 'Install Miro', command: 'Web-based platform' },
      { step: 'Install draw.io desktop', command: 'sudo snap install drawio' },
      { step: 'Install Jupyter Notebook', command: 'pip3 install jupyter' }
    ]
  },
  senior: {
    macos: [
      { step: 'Install Advanced Analytics Suite', command: 'Configure enterprise analytics platforms' },
      { step: 'Install Executive Dashboard Tools', command: 'Set up executive reporting tools' },
      { step: 'Install Strategic Planning Tools', command: 'Configure strategic planning platforms' },
      { step: 'Install Customer Interview Tools', command: 'Set up customer research platforms' }
    ],
    windows: [
      { step: 'Install Advanced Power BI', command: 'Configure Power BI Premium features' },
      { step: 'Install Azure Analytics', command: 'Set up Azure Analytics workspace' },
      { step: 'Install Microsoft Project', command: 'choco install microsoft-project' },
      { step: 'Install Dynamics 365', command: 'Configure Dynamics 365 for customer insights' }
    ],
    linux: [
      { step: 'Install Advanced Python Stack', command: 'pip3 install scikit-learn tensorflow plotly dash streamlit' },
      { step: 'Install Docker for Analytics', command: 'docker pull jupyter/datascience-notebook' },
      { step: 'Install Apache Superset', command: 'pip install apache-superset' },
      { step: 'Install Metabase', command: 'docker run -d -p 3000:3000 --name metabase metabase/metabase' }
    ]
  }
};
